import { type TSportType, VIDEO_SOURCE_TYPE } from "~/types";

// Record<string, IEventStatus>
export const EVENT_STATUS = {
  LIVE: "live",
  UPCOMING: "upcoming",
  VOD: "vod",
} as const;

// Record<string, TVideoType | 'playlist'>
export const VIDEO_TYPE = {
  EVENT: "event",
  CLIP: "clip",
  PLAYLIST: "playlist",
  GAME_HIGHLIGHT: "highlight",
  ATHLETE_HIGHLIGHT: "player-highlight",
} as const;

export const SOURCE_TYPE = {
  VIDEO: "video",
  PLAYLIST: "playlist",
} as const;

export const PLAYLIST_TYPE = {
  SYSTEM: "system",
  PRIVATE: "private",
} as const;

export const EVENT_TYPES = {
  GAME: "game",
  PRACTICE: "practice",
  SCRIMMAGE: "scrimmage",
  SCOUT: "scout",
  OTHER: "other",
} as const;

export const EVENT_SUBTYPES = {
  SHARED: "shared",
  SCOUT: "scout",
} as const;

export const EVENT_TYPE_ICONS = {
  [EVENT_TYPES.GAME]: "matches",
  [EVENT_TYPES.PRACTICE]: "practice",
  [EVENT_TYPES.SCRIMMAGE]: "scrimmage",
  [EVENT_TYPES.SCOUT]: "scout",
  [EVENT_TYPES.OTHER]: "movie",
  default: "empty",
} as const;

export const PLAY_BASED_GAMES = ["canadian-football", "flag-football", "american_footbal", "outdoor-football", "baseball", "softball", "cricket"];
export const FLOW_BASED_GAMES_WITH_STATS_FROM_SM = [
  "basketball",
  "soccer",
  "water-polo",
  "volleyball",
  "fieldhockey",
  "rugby",
  "netball",
  "lacrosse-men",
  "lacrosse-women",
];

export const SPORT_TYPES_WITHOUT_ATHLETE_STATS: TSportType[] = ["water-polo", "netball", "rugby"];
// Sport types that are supported for PDF export, each sport type must have a corresponding cover image in the public/images/pdf/covers folder
export const ALLOWED_SPORT_TYPES_FOR_PDF_EXPORT: TSportType[] = [
  "basketball",
  "volleyball",
  "hockey",
  "soccer",
  "futsal",
  "handball",
  "water-polo",
  "fieldhockey",
  "lacrosse-men",
  "lacrosse-women",
];

export const SPORT_TYPES_WITH_ADV_CHARTS: TSportType[] = ["basketball", "soccer"];

export const SHARED_DOWNLOADABLE_FILES_SOURCE_TYPE = {
  FULL: "full",
  CLIPPED: "clipped",
} as const;

export const SHARED_DOWNLOADABLE_FILES_ANGLE_VIDEO_TYPE_MAP = {
  [SHARED_DOWNLOADABLE_FILES_SOURCE_TYPE.FULL]: VIDEO_SOURCE_TYPE.CONTINUOUS,
  [SHARED_DOWNLOADABLE_FILES_SOURCE_TYPE.CLIPPED]: VIDEO_SOURCE_TYPE.CLIPPED,
} as const;

export const EVENTS_TABS = {
  MY_VIDEOS: "my-videos",
  SCOUT: "scout",
} as const;

export const EVENTS_SECTION_TYPES = [EVENT_STATUS.LIVE, EVENT_STATUS.UPCOMING, EVENT_STATUS.VOD, EVENT_SUBTYPES.SHARED, EVENT_SUBTYPES.SCOUT] as const;
export const EVENTS_TYPES_WITH_OPPONENT_TEAM = [EVENT_TYPES.GAME, EVENT_TYPES.SCRIMMAGE, EVENT_TYPES.SCOUT] as const;

// Event types that should have home/away teams swapped for US users
export const EVENT_TYPES_WITH_HOME_AWAY_TEAM = [EVENT_TYPES.GAME, EVENT_TYPES.OTHER, EVENT_TYPES.SCRIMMAGE, EVENT_TYPES.SCOUT] as const;
